export const LIKE_BUTTON_TEST_ID = "like-button";
